// extracted by mini-css-extract-plugin
export var container = "_hg-0";
export var content = "_hg-3";
export var customerTitle = "_hg-4";
export var empty = "_hg-5";
export var gray = "_hg-6";
export var header = "_hg-7";
export var info = "_hg-8";
export var loading = "_hg-2";
export var loadingCard = "_hg-9";
export var oneLine = "_hg-a";
export var personName = "_hg-e";
export var pillContainer = "_hg-b";
export var selected = "_hg-1";
export var text = "_hg-c";
export var twoLines = "_hg-d";
export var unread = "_hg-f";
export var unreadIndicator = "_hg-g";